import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Main from './views/Main.vue'
import Detail from './views/Detail.vue'
import InventoryList from './views/InventoryList.vue'
import InventoryListDetail from './views/InventoryListDetail.vue'
import OrganizationManage from './views/OrganizationManage.vue'
// import axios from 'axios'
// import qs from 'qs'
// import { storage } from './util/'
// import cookie from './util/cookie.js'

Vue.use(Router)

let mainChildren = [
  {
    path: 'inventoryList',
    name: 'inventoryList',
    component: InventoryList
  },
  {
    path: '/manage',
    name: 'manage',
    component: OrganizationManage
  }
]

let inventoryListChildren = [
  {
    path: 'inventoryListDetail/:detailId',
    name: 'inventoryListDetail',
    component: InventoryListDetail
  }
]

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      children: mainChildren
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail,
      children: inventoryListChildren
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }

  ]
})
// router.beforeEach(async (to, from, next) => {
//   // if (to.name === 'login') { next() }
//   let autoLogin = cookie.getItem('autoLogin')
//   if (autoLogin) {
//     if (autoLogin === 'true') {
//       next({ name: 'inventoryList' })
//     } else {
//       next({ name: 'login' })
//     }
//   } else {
//     console.log(1)
//     next({ name: 'login' })
//   }
// })

export default router
